import { CustomFilterProps, customFilters } from './customFilters'
import store from 'utils/store/withMiddleware'
interface StateCustomFilters {
  [stateAcronym: string]: CustomFilterProps
}

function customFiltersByState(stateCustomFilters: StateCustomFilters) {
  const state = store.getState()

  const stateAcronym = state.hcStorage.location.state_acronym
  const customFilterOptions = stateCustomFilters[stateAcronym]
  if (!customFilterOptions) {
    return
  }

  customFilters(customFilterOptions)
}

export default customFiltersByState
